export const ActionTypes = {
  OTP_SUCCESS: "OTP_SUCCESS",
  OTP_FAIL: "OTP_FAIL",
  OTP_LOADING: "OTP_LOADING"
};
